import api from './api';

export const domainService = {
  sync: (brandId) => api.post(`/domains/${brandId}/sync`),
  
  getAll: (brandId, params) => api.get(`/domains/${brandId}`, { params }),
  
  createRedirect: (domainId, targetUrl) => 
    api.post(`/domains/${domainId}/redirect`, { target_url: targetUrl }),
};
